export const CompositionFirstLevel = {
	allocation: "ALLOCATION",
	holdings: "HOLDINGS",
} as const;
export type CompositionFirstLevel = (typeof CompositionFirstLevel)[keyof typeof CompositionFirstLevel];

export const COMPOSITION_GROUP_BY_UNGROUP = "UNGROUP";

export type CompositionGroupBy = {
	firstLevel: CompositionFirstLevel;
	secondLevel: string;
};

export const DEFAULT_COMPOSITION_GROUP_BY: CompositionGroupBy = {
	firstLevel: CompositionFirstLevel.allocation,
	secondLevel: COMPOSITION_GROUP_BY_UNGROUP,
};
